import { z } from 'zod'

export const DynDNSRecordType = z.enum(['A', 'AAAA', 'BOTH'])

export type DynDNSRecordType = z.infer<typeof DynDNSRecordType>

export const DynDNSToken = z.object({
  id: z.number(),
  hostname: z.string(),
  record_type: DynDNSRecordType,
  last_ipv4: z.string().nullable().optional(),
  last_ipv6: z.string().nullable().optional(),
  last_update: z.string().nullable().optional(),
  last_error: z.string().nullable().optional(),
  next_allowed_update: z.string().nullable().optional(),
  active: z.boolean(),
  description: z.string().nullable().optional(),
  created: z.string(),
  domain_id: z.number(),
  domain_name: z.string()
})

export type DynDNSToken = z.infer<typeof DynDNSToken>

export const DynDNSCreateRequest = z.object({
  hostname: z.string().optional(),
  record_type: DynDNSRecordType.optional(),
  description: z.string().optional()
})

export type DynDNSCreateRequest = z.infer<typeof DynDNSCreateRequest>

export const DynDNSCreateResponse = z.object({
  token: z.string(),
  info: DynDNSToken
})

export type DynDNSCreateResponse = z.infer<typeof DynDNSCreateResponse>
